import { Modal } from 'bootstrap';

export default class ProductDetailPage {
    constructor() {
        console.info('ProductDetailPage.constructor()');

        this.initListeners();
    }

    initListeners() {
        console.info('ProductDetailPage.initListeners()');

        const jsShowNowButton = document.querySelector('.js-show-now');
        jsShowNowButton.addEventListener('click', (event) => {
            const modalElement = document.getElementById('modal--shop-now');
            const modal = new Modal(modalElement);
            modal.show();
        });

        // Add event listener for modal close button
        const closeButton = document.querySelector('#modal--shop-now .close');
        if (closeButton) {
            closeButton.addEventListener('click', (event) => {
                const modalElement = document.getElementById('modal--shop-now');
                const modal = Modal.getInstance(modalElement);
                modal.hide();
            });
        }

    }
}
